import { environment } from '../../../environment/environment';
import http from '../../../helpers/http';

export const resetPassword = ({ email }) => {
  return http.post(`${environment.apiUrl}/auth/reset`, { email });
};
